import Link from "next/link";
import ShoppingCart from "./cart/shoppingCart";
import FunCentre from "./funCentre";
import UserRewardDetails from "./userRewardDetails";
import { UserMenus } from "./types";
import LoginAndSignUp from "./loginAndSignUp";

type RightMenusProps = {
  userData: UserMenus;
  isBotBPassHeader: boolean;
  milestoneData: string;
};

const RightMenus = ({ userData, isBotBPassHeader, milestoneData }: RightMenusProps) => {
  return isBotBPassHeader ? (
    <div
      className="flex gap-4 items-center justify-end w-[40%] descriptionContainer"
      dangerouslySetInnerHTML={{ __html: milestoneData }}
    />
  ) : (
    <div className="flex gap-4 items-center justify-end w-[40%]">
      {!userData?.IsAuthenticated && <LoginAndSignUp loginURL={userData?.LoginUrl} signUpURL={userData?.SignupUrl} />}
      {userData?.IsAuthenticated && userData.FunCentre !== null && <FunCentre smarticoData={userData?.FunCentre} />}
      {userData?.IsAuthenticated && <UserRewardDetails userData={userData} isDesktop={true} />}
      {userData?.IsAuthenticated && userData?.MyAvatar !== null && (
        <Link href={"/account"} title={userData?.MyAvatar.ProfileTitle}>
          {userData?.MyAvatar.ProfileImageURL ? (
            <img
              src={userData?.MyAvatar.ProfileImageURL}
              alt="user-avatar-image"
              className="border-2 border-solid border-[#ff8200] overflow-hidden max-w-[44px] max-h[44px] rounded-full"
            />
          ) : (
            <svg
              className="cursor-pointer"
              width="28"
              height="29"
              viewBox="0 0 28 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.196 22.4519C7.48476 21.4909 8.07563 20.6485 8.88095 20.0497C9.68628 19.451 10.6632 19.1278 11.6667 19.1281H16.3333C17.3381 19.1277 18.3162 19.4517 19.1221 20.0518C19.928 20.652 20.5187 21.4962 20.8063 22.4589M3.5 14.4614C3.5 15.8403 3.77159 17.2057 4.29926 18.4796C4.82694 19.7535 5.60036 20.911 6.57538 21.886C7.55039 22.8611 8.70791 23.6345 9.98182 24.1622C11.2557 24.6898 12.6211 24.9614 14 24.9614C15.3789 24.9614 16.7443 24.6898 18.0182 24.1622C19.2921 23.6345 20.4496 22.8611 21.4246 21.886C22.3996 20.911 23.1731 19.7535 23.7007 18.4796C24.2284 17.2057 24.5 15.8403 24.5 14.4614C24.5 13.0825 24.2284 11.7172 23.7007 10.4432C23.1731 9.16933 22.3996 8.01182 21.4246 7.0368C20.4496 6.06179 19.2921 5.28837 18.0182 4.76069C16.7443 4.23302 15.3789 3.96143 14 3.96143C12.6211 3.96143 11.2557 4.23302 9.98182 4.76069C8.70791 5.28837 7.55039 6.06179 6.57538 7.0368C5.60036 8.01182 4.82694 9.16933 4.29926 10.4432C3.77159 11.7172 3.5 13.0825 3.5 14.4614ZM10.5 12.1281C10.5 13.0563 10.8687 13.9466 11.5251 14.603C12.1815 15.2593 13.0717 15.6281 14 15.6281C14.9283 15.6281 15.8185 15.2593 16.4749 14.603C17.1313 13.9466 17.5 13.0563 17.5 12.1281C17.5 11.1998 17.1313 10.3096 16.4749 9.65322C15.8185 8.99684 14.9283 8.62809 14 8.62809C13.0717 8.62809 12.1815 8.99684 11.5251 9.65322C10.8687 10.3096 10.5 11.1998 10.5 12.1281Z"
                stroke="#4C4C52"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"></path>
            </svg>
          )}
        </Link>
      )}
      {document.querySelector(".checkout") === null && <ShoppingCart />}
    </div>
  );
};

export default RightMenus;
